import script from "./SelectorPosicionFirmaVidSigner.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectorPosicionFirmaVidSigner.vue?vue&type=script&setup=true&lang=js"

import "./SelectorPosicionFirmaVidSigner.vue?vue&type=style&index=0&id=2373b4ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2373b4ce"]])

export default __exports__